"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabMatchesSearch = tabMatchesSearch;
/**
 * Free-text match over a party, for the till: a customer says their name and the
 * cashier needs the tab. Also matches a device or an invoice number, because
 * "the lads on PC-7" and a printed slip are the other two ways a party gets
 * identified at the counter.
 *
 * Client-side on purpose — the whole floor arrives in one payload, so filtering
 * locally is instant and works while the venue's uplink is down (SPEC §2).
 */
function tabMatchesSearch(tab, search) {
    const needle = search.trim().toLowerCase();
    if (needle === '')
        return true;
    return (tab.name.toLowerCase().includes(needle) ||
        tab.sessions.some((session) => session.deviceName.toLowerCase().includes(needle)) ||
        tab.orders.some((order) => order.invoiceNumber.toLowerCase().includes(needle) ||
            order.destinationName.toLowerCase().includes(needle) ||
            order.itemSummary.toLowerCase().includes(needle)));
}
//# sourceMappingURL=outstanding.js.map